import React, { Component } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import countries from 'i18n-iso-countries'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from '@mui/material'

class Payments extends Component {

  state = {
    lastname: "",
    firstname: "",
    amount: "0.00",
    street: "",
    country: "Trinidad and Tobago",
    card: "",
    cvv: "",
    expiry: "",
    openAlert: false,
    alertMessage: "",
    openPayConfirm: false,
    payConfirmMessage: "",
    payConfirmTitle: ""
  };


  onChange = (e) => {
    if (e.target.id === "firstname" || e.target.id === "lastname"){
        if (/^[a-zA-Z][a-zA-Z\s]*$/.test(e.target.value) || e.target.value ===""){
          this.setState({ [e.target.id]: e.target.value })
        }
      }  else if (e.target.id === "cvv") {
        
        if ((/^[0-9]*$/.test(e.target.value) || e.target.value ==="") && e.target.value.length <= 4 ){
            this.setState({ [e.target.id]: e.target.value })
        }
      } else if (e.target.id === "expiry"){
        if ( e.target.value === "" || e.target.value.length <= 5 ){

          var newdate = e.target.value.replace(
              /[^0-9]/g, '' // To allow only numbers
          ).replace(
              /^([2-9])$/g, '0$1' // To handle 3 > 03
          ).replace(
              /^(1{1})([3-9]{1})$/g, '0$1/$2' // 13 > 01/3
          ).replace(
              /^0{1,}/g, '0' // To handle 00 > 0
          ).replace(
              /^([0-1]{1}[0-9]{1})([0-9]{1,2}).*/g, '$1/$2' // To handle 113 > 11/3
          );


          this.setState({ [e.target.id]: newdate })
      }
      } else if (e.target.id === "card") {
        
        if ((/^[0-9][0-9\s]*$/.test(e.target.value) || e.target.value ==="") && e.target.value.replace(/\s+/g, '').length <= 16 ){
            this.setState({ [e.target.id]: this.cc_format(e.target.value.replace(/\s/g,'') )})
        }
      } 
      else {
        this.setState({ [e.target.id]: e.target.value })
      } 
      
    }

     cc_format(value) {
      var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
      var matches = v.match(/\d{4,16}/g);
      var match = matches && matches[0] || ''
      var parts = []
      var i;
      var len;
      for (i=0, len=match.length; i<len; i+=4) {
          parts.push(match.substring(i, i+4))
      }
  
      if (parts.length) {
          return parts.join(' ')
      } else {
          return value
      }
  }

    

    onChangeCountry = (e) => {
      this.setState({ 'country': e.target.value })
    }

    handleAlertClose = () => {
      this.setState({
        openAlert: false
      });
    };

    handlePayAlertClose = () => {
      this.setState({
        openPayConfirm: false
      });
    };

  componentDidMount() {
    this.setState({
      lastname: this.props.loginInfo.lastName,
      firstname: this.props.loginInfo.firstName,
      amount: this.props.balance ? this.props.balance.toFixed(2) : "0.00",
      steet: "",
      country: "Trinidad and Tobago",
      card: "",
      cvv: "",
      expiry: ""
    })
    countries.registerLocale(require("i18n-iso-countries/langs/en.json"));  
  }

  validateForm = () => {
    var dt = new Date()
    if (this.state.firstname === "") {
      this.setState({
        openAlert: true,
        alertMessage: "Firstname cannot be empty"
      });
      return false
    } else if (this.state.lastname === "") {
      this.setState({
        openAlert: true,
        alertMessage: "Lastname cannot be empty"
      });
      return false
    } else if (this.state.street === "") {
      this.setState({
        openAlert: true,
        alertMessage: "Street address cannot be empty"
      });
      return false
    } else if (this.state.amount === "") {
      this.setState({
        openAlert: true,
        alertMessage: "Amount cannot be empty"
      });
      return false
    } else if (this.state.card === "") {
      this.setState({
        openAlert: true,
        alertMessage: "Card number cannot be empty"
      });
      return false
    } else if (this.state.expiry === "") {
      this.setState({
        openAlert: true,
        alertMessage: "Expiry date cannot be empty"
      });
      return false
    } else if (this.state.cvv === "" || this.state.cvv.length < 3) {
      this.setState({
        openAlert: true,
        alertMessage: "Card security code is invalid"
      });
      return false
    } else if (this.state.card.replace(/\s/g,'').length < 13 || this.state.card.replace(/\s/g,'').length > 16) {
      this.setState({
        openAlert: true,
        alertMessage: "Invalid credit card number"
      });
      return false
    } else if (parseFloat(this.state.amount) <= 0 ){
      this.setState({
        openAlert: true,
        alertMessage: "Amount must be greater than $0.00"
      });
      return false
    } else if (this.state.lastname === this.state.firstname){
      this.setState({
        openAlert: true,
        alertMessage: "Invalid name"
      });
      return false
    } else if (this.state.expiry.length !==5){
      this.setState({
        openAlert: true,
        alertMessage: "Invalid expiry date"
      });
      return false
    } else if (parseInt("20"+this.state.expiry.slice(-2)) < dt.getFullYear()){
      this.setState({
        openAlert: true,
        alertMessage: "Credit card is expired"
      });
      return false
    } else if (parseInt("20"+this.state.expiry.slice(-2)) === dt.getFullYear()){
      if(parseInt(this.state.expiry.slice(0,2)) < dt.getMonth()+1) {
        this.setState({
          openAlert: true,
          alertMessage: "Credit card is expired"
        });
        return false
    }
    }

    return true
  }



  handleSubmitPayment = () => {
    if (this.validateForm() === true) {
      this.setState({
        openPayConfirm: true,
        payConfirmTitle: "Kindly confirm your payment of $" + this.state.amount +" for Account " +  this.props.loginInfo.username +".",
        payConfirmMessage: "Please do not close the small window that will appear. It is necessary for processing your payment. " +
        "If you did not observe a pop-up window, please ensure you enable pop-ups in your browser or disable your pop-up blocker."
      });
    }
    
  }

  sendPayment = () => {
    this.setState({
      openPayConfirm: false,
      payConfirmMessage: "",
      payConfirmTitle: ""
    });
    var alpha3 = countries.getAlpha3Code(this.state.country, "en")
      var code = countries.alpha3ToNumeric(alpha3)
      var form = {
        "cardNumber": this.state.card.replace(/\s/g,''),
        "expiry": this.state.expiry.replace(/\//g,''),
        "cvv": this.state.cvv,
        "amount": parseFloat(this.state.amount),
        "firstName": this.state.firstname,
        "lastName": this.state.lastname,
        "streetAddress": this.state.street,
        "country": parseInt(code,10)
      }
      this.props.submitPayment(form)
  }


  render() {
    return (
      <div>
        < AppBar position="fixed"
          style={
            {
              marginLeft: 260,
              backgroundColor: "#55565A"
            }
          } >
          <Toolbar>
            <Typography variant="h5" style={{ marginLeft: 260 }}>
              Make Payment
          </Typography>
          </Toolbar>
        </AppBar>
        
      
        <Paper position="fixed" align="center" style={{
          marginTop: 100,
          paddingTop: 20,
          height: 100,
          //width: "100%",
          marginLeft: 300,
          marginRight: 40
        }}>
          <Typography variant="h5">Make Payment</Typography>
          <Typography >
            (Your credit card information will not be stored)
          </Typography>
          <Typography variant="h6">
            Customer: { this.props.loginInfo.firstName + " " + this.props.loginInfo.lastName }&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{this.props.loginInfo.username}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Amount due: ${this.props.balance ? this.props.balance.toFixed(2) : "0.00"}
          </Typography>
          </Paper>
          <Paper align="center" style={{
            marginTop: 0,
            padding: 10,
            marginLeft: 300,
            marginRight: 40,
            marginBottom: 60

          }}>
                <div>
                <Typography variant="h6">Billing Information</Typography>
                <TextField id="firstname" 
                  value={this.state.firstname}
                  onChange={this.onChange}
                  //label="Firstname" 
                  placeholder="Firstname" 
                  type="text"
                  inputProps={{ disableUnderline: true, sx: { color: 'black', p:1 }}}
                  inputLabelProps={{
                    shrink: true,
                    disabled: true,
                    required: true,
                    style: {
                      color: 'black',
                      //padding: '0 13px',
                    }
                  }}
                  style={{
                  background: 'white',
                  borderRadius: 5,
                  border: 0,
                  height: 39,
                  width: 250,
                  // paddingLeft: '10px',
                  // paddingTop: '6px',
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 20,
                  marginRight: 20,
                }}/>
                <TextField id="lastname" 
                  value={this.state.lastname}
                  onChange={this.onChange}
                  //label="Lastname"
                  placeholder="Lastname"
                  type="text"
                  inputProps={{ disableUnderline: true, sx: { color: 'black', p:1 }}}
                  inputLabelProps={{
                    shrink: true,
                    disabled: true,
                    required: true,
                    style: {
                      color: 'black',
                      padding: '0 13px',
                    }
                  }}
                  style={{
                  background: 'white',
                  color: "black",
                  borderRadius: 5,
                  border: 0,
                  height: 39,
                  width: 250,
                  // padding: '0 10px',
                  // paddingTop: '6px',
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 20,
                  marginRight: 20,
                }}/>
                </div>
                <div>
                <TextField id="street" 
                  value={this.state.street}
                  onChange={this.onChange}
                  //label="Street address" 
                  placeholder= "Street address"
                  type="text"
                  inputProps={{ disableUnderline: true, sx: { color: 'black', p:1 }}}
                  inputLabelProps={{
                    shrink: true,
                    disabled: true,
                    required: true,
                    style: {
                      color: 'black',
                      padding: '0 13px',
                    }
                  }}
                  style={{
                  background: 'white',
                  color: "black",
                  borderRadius: 5,
                  border: 0,
                  height: 39,
                  width: 540,
                  // padding: '0 10px',
                  // paddingTop: '6px',
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 20,
                  marginRight: 20,
                }}/>
                </div>
                <div>
                <TextField id="country" 
                value={this.state.country}
                onChange={this.onChangeCountry}
                //label="Country"
                placeholder="Country"
                select
                inputProps={{ disableUnderline: true, sx: { color: 'black', p:1 }}}
                inputLabelProps={{
                    shrink: true,
                    disabled: true,
                    required: true,
                    style: {
                      color: 'black',
                      padding: '0 13px',
                    }
                  }}
                  style={{
                  background: 'white',
                  color: "black",
                  borderRadius: 5,
                  border: 0,
                  height: 39,
                  width: 250,
                  // padding: '0 10px',
                  // paddingTop: '6px',
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 20,
                  marginRight: 20,
                }}>
                {Object.values(countries.getNames("en", {select: "official"})).map(n=> {
                  return <MenuItem key={n} value={n}>{n}</MenuItem>
                })}
                  
                </TextField>
                <TextField id="amount" 
                value={this.state.amount}
                onChange={this.onChange}
                //label="Payment amount" 
                placeholder="Payment amount" 
                type="number"
                inputProps={{ disableUnderline: true, sx: { color: 'black', p:1 }}}
                inputLabelProps={{
                    shrink: true,
                    disabled: true,
                    required: true,
                    style: {
                      color: 'black',
                      padding: '0 13px',
                    }
                  }}
                  style={{
                  background: 'white',
                  color: "black",
                  borderRadius: 5,
                  border: 0,
                  height: 39,
                  width: 250,
                  // padding: '0 10px',
                  // paddingTop: '6px',
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 20,
                  marginRight: 20,
                }}/>
                </div>
                <div>
                <Typography variant="h6">Credit Card Information</Typography>
                <TextField id="card" 
                value={this.state.card}
                onChange={this.onChange}
                //label="Card number" 
                placeholder="Card number" 
                type="text"
                inputProps={{ disableUnderline: true, sx: { color: 'black', p:1 }}}
                inputLabelProps={{
                    shrink: true,
                    disabled: true,
                    required: true,
                    style: {
                      color: 'black',
                      padding: '0 13px',
                    }
                  }}
                  style={{
                  background: 'white',
                  color: "black",
                  borderRadius: 5,
                  border: 0,
                  height: 39,
                  width: 540,
                  // padding: '0 10px',
                  // paddingTop: '6px',
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 20,
                  marginRight: 20,
                }}/>
                </div>
                <div>
                <TextField id="expiry" 
                value={this.state.expiry}
                onChange={this.onChange}
                //label="Expiry date" 
                placeholder= "MM/YY"
                type="text"
                inputProps={{ disableUnderline: true, sx: { color: 'black', p:1 }}}
                inputLabelProps={{
                    shrink: true,
                    disabled: true,
                    required: true,
                    style: {
                      color: 'black',
                      padding: '0 13px',
                    }
                  }}
                  style={{
                  background: 'white',
                  color: "black",
                  borderRadius: 5,
                  border: 0,
                  height: 39,
                  width: 250,
                  // padding: '0 10px',
                  // paddingTop: '6px',
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 20,
                  marginRight: 20,
                }}/>
                <TextField id="cvv" 
                value={this.state.cvv}
                onChange={this.onChange}
                //label="Card security code" 
                placeholder="Card security code" 
                type="text"
                inputProps={{ disableUnderline: true, sx: { color: 'black', p:1 }}}
                inputLabelProps={{
                    shrink: true,
                    disabled: true,
                    required: true,
                    style: {
                      color: 'black',
                      padding: '0 13px',
                    }
                  }}
                  style={{
                  background: 'white',
                  color: "black",
                  borderRadius: 5,
                  border: 0,
                  height: 39,
                  width: 250,
                  // padding: '0 10px',
                  // paddingTop: '6px',
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 20,
                  marginRight: 20,
                }}/>
                </div>
                <div>
                <Button variant="contained" color="primary"
                onClick={this.handleSubmitPayment}
                style={
                  {
                    background: '#47ED3E',
                    fontWeight: 'bold',
                    borderRadius: 5,
                    border: 0,
                    color: '#55565A',
                    height: 40,
                    padding: '0 30px',
                    width: 200,
                    marginBottom: 10,
                    //marginLeft: 50,
                    //marginRight: 'auto',
                    marginTop: 20,
                    align: 'center'
                  }}
                >
                  Make Payment
                </Button> 
                </div>
                {/* </FormControl> */}
              
              </Paper>
              <Dialog
            open={
              this.state.openAlert
            }
            PaperProps={{ sx: { background: '#55565A' } }}


            onClose={this.handleAlertClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent
              >
              <DialogContentText 
              id="alert-dialog-description"
>
                {this.state.alertMessage}

              </DialogContentText>
            </DialogContent>
            <DialogActions>

              <Button onClick={this.handleAlertClose} sx={{ color: 'white' }} autoFocus>
                OK
            </Button>
              
            </DialogActions>
            
          </Dialog>
          <Dialog
            open={
              this.state.openPayConfirm
            }
            PaperProps={{ sx: { background: '#55565A' } }}

            onClose={this.handlePayAlertClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
            <DialogTitle>{this.state.payConfirmTitle}</DialogTitle>
              <DialogContentText 
              id="alert-dialog-description">
                {this.state.payConfirmMessage}

              </DialogContentText>
            </DialogContent>
            <DialogActions>

              <Button onClick={this.handlePayAlertClose} style={{ color: 'white' }} autoFocus>
                CANCEL
            </Button>
            <Button onClick={this.sendPayment} style={{ color: 'white' }} autoFocus>
                OK
            </Button>
              
            </DialogActions>
            
          </Dialog>
      </div>
    )

  }
}
export default Payments